import { useSetRecoilState } from 'recoil';

import { rightSideBarTabState } from 'state/atoms';

interface UseDataNodeParams {
  prefix: string;
}

const useDataNode = ({ prefix }: UseDataNodeParams) => {
  const setViewerMenu = useSetRecoilState(rightSideBarTabState);

  const handleInfoClick = () => {
    if (prefix === 'csv') {
      setViewerMenu('nodeInfo');
    }
    if (prefix === 'image') {
      setViewerMenu('nodeInfo');
    }
  };

  return {
    onInfoClick: handleInfoClick,
  };
};

export default useDataNode;
